import sortBy from "lodash/sortBy";
import includes from "lodash/includes";
import last from "lodash/last";

export const PREVENT_OVERLAP_THRESHOLD = 30;

export default function createCuepointBuckets({
  cuepoints,
  chapterDuration,
  sliderWidth,
}) {
  const buckets = [];
  const cuepointsInBuckets = [];
  let currentBucket;

  function getCuepointX(cuepoint) {
    return Math.round((cuepoint.startTime / chapterDuration) * sliderWidth);
  }

  const applicableCuepoints = sortBy(cuepoints, "startTime");

  applicableCuepoints.forEach((cuepoint, index) => {
    if (!includes(cuepointsInBuckets, cuepoint)) {
      // This cuepoint is not already in a bucket.

      if (!currentBucket) {
        // There is no current bucket. Add this cuepoint and all in
        // range to the bucket and then reset the bucket reference.

        // Create new bucket with this `cuepoint`.
        currentBucket = {
          startTime: cuepoint.startTime,
          cuepoints: [cuepoint],
        };

        // Mark this cuepoint as being in a bucket already.
        cuepointsInBuckets.push(cuepoint);

        // Add this bucket to the final result.
        buckets.push(currentBucket);

        // Loop through all cuepoints later in the array.
        applicableCuepoints.slice(index + 1).forEach((futureCuepoint) => {
          if (currentBucket) {
            const futureLeft = getCuepointX(futureCuepoint);
            const previousCuepointLeft = getCuepointX(
              last(currentBucket.cuepoints),
            );

            if (futureLeft - previousCuepointLeft < PREVENT_OVERLAP_THRESHOLD) {
              // The difference is less than `PREVENT_OVERLAP_THRESHOLD`. This
              // cuepoint needs to go in the same bucket.

              // Put this `futureCuepoint` in the bucket.
              currentBucket.cuepoints.unshift(futureCuepoint);

              // Mark this future cuepoint as being in a bucket.
              cuepointsInBuckets.push(futureCuepoint);
            } else {
              // There are no more future cuepoints that will go in
              // this bucket. Add the current bucket to the final
              // array and clear the current bucket reference.
              currentBucket = null;
            }
          }
        });
      }
    }
  });

  return buckets;
}
